import { type GetVitalSignsResponse, OutputApi } from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class OutputService {
  static readonly outputApi = new OutputApi(globalApiConfig)

  static async getLatestOutputVitalSigns(id: string): Promise<GetVitalSignsResponse> {
    return (await OutputService.outputApi.getLatestOutputVitalSigns(id, ['URINE'])).data
  }
}
